import { reportsGlob } from "./reports";
import { reportingGlob } from "./reporting";
import { feedbackGlob } from "./feedback";
import { exportsGlob } from "./exports";
import { tokenGlob } from "./tokens";
import { typesGlob } from "./types";
import { subjectGlob } from "./subjects";
import { businessGlob } from "./businesses";
import { proxiesGlob } from "./proxies";
import { customersGlob } from "./customers";
import { noticesGlob } from "./notices";

export const globs = {
	proxies: proxiesGlob(),
	business: businessGlob(),
	customers: customersGlob(),
	reporting: reportingGlob(),
	reports: reportsGlob(),
	feedback: feedbackGlob(),
	exports: exportsGlob,
	entityTypes: typesGlob(),
	subjects: subjectGlob(),
	tokens: tokenGlob(),
	notices: noticesGlob()
};

export const anyOf = (base: string) => `${base}/**/*`;
export { INVENTORY_OPERATIONS } from "./types/inventory/operations";
export type { InventoryOperationTypes } from "./types/inventory/operations";